/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const TableSkeleton = (): JSX.Element => {
  // 4 cards displaying a skeleton
  const grids = new Array(4).fill(null);

  return (
    <Grid container justifyContent="center" spacing={2}>
      {grids.map(() => (
        <Grid
          item
          css={{
            marginBottom: '2em',
          }}
          xs={3}
        >
          <Skeleton variant="rect" width="100%" height={150} />
        </Grid>
      ))}
    </Grid>
  );
};

export default TableSkeleton;
